/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateTopicRequest
 */
export interface UpdateTopicRequest {
    /**
     * A human-readable name for the topic.
     * @type {string}
     * @memberof UpdateTopicRequest
     */
    name: string;
}

/**
 * Check if a given object implements the UpdateTopicRequest interface.
 */
export function instanceOfUpdateTopicRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function UpdateTopicRequestFromJSON(json: any): UpdateTopicRequest {
    return UpdateTopicRequestFromJSONTyped(json, false);
}

export function UpdateTopicRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTopicRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function UpdateTopicRequestToJSON(value?: UpdateTopicRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

